module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Introduction")])]), _c('figure', {
    staticClass: "figbas",
    attrs: {
      "id": "P1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "",
      "src": "images/P1.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Many readers of "), _c('i', [_vm._v("Barefoot")]), _vm._v(" have requested a guide for exploring the spiritual formation themes within the novel and for processing the characters’ journeys with God and each other. In response, I’m delighted to provide this study guide as a resource for individuals and groups"), _c('i', [_vm._v(". ")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Here you’ll find twelve weeks of daily Scripture reading, reflection questions, and invitations to prayer. Some weeks you’ll have five days of reflection questions with the sixth day designated as a review day. Other weeks days five and six will both provide opportunities for prayerful review. At the end of each week you’ll also find spiritual disciplines you may wish to incorporate more intentionally into your life with God, and group discussion questions and exercises to explore and practice in community.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("You can decide whether to read "), _c('i', [_vm._v("Barefoot")]), _vm._v(" first in its entirety and then return to do a slow study with the guide, or whether to read it a section at a time, matching your pace to the daily questions. I do recommend keeping a travelogue of your journey. Even if you aren’t in the habit of using a journal, you’ll benefit from having a record of what you’re noticing as you move forward.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Not every question will resonate with you. That’s okay. You don’t need to answer every question every day. But do watch for any impulse to avoid a question because it agitates you or makes you feel uncomfortable. That’s probably the very question you need to spend time pondering! If you don’t have time to answer the questions you want to reflect on, simply mark them and return on the review days. If something in the chapter speaks to you and isn’t addressed in a question, spend time journaling and praying about it.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The daily Scripture texts echo the themes of the daily readings from the book. I recommend reading the Scripture first so that the Word shapes and frames your pondering.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I pray you’ll encounter God in significant ways as you read, reflect, and pray. May you find many opportunities to remove your shoes and worship on holy ground.")]), _c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("Sharon Garlough Brown")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0